import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 查询 ");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("确认");

import { ref, computed, watch } from 'vue';
import { getVexTableProps } from '@/config';
import { getProdCenterData } from '@/request';
import { ElMessage } from 'element-plus';
export default {
  name: 'AddProductModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    beforeSuccess: {
      type: [Function, null],
      default: null
    },
    selectedIds: {
      type: Array,
      default: () => []
    },
    checkMode: {
      type: String,
      default: 'radio'
    },

    /** 选品查询接口，默认商品中心；品种库可传 getVarietyGoodsList */
    queryApi: {
      type: Function,
      default: null
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const table = ref();
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const form = ref({
      name: '',
      manufacture: ''
    });
    watch(() => props.modelValue, newVal => {
      if (newVal) {
        form.value = {
          name: '',
          manufacture: ''
        };
      }
    });
    const tableOptions = getVexTableProps({
      columns: [{
        type: props.checkMode,
        width: '50px'
      }, {
        title: '商品名称',
        field: 'prodName',
        width: '200px',
        showOverflow: true
      }, {
        title: '厂家',
        field: 'manufacture',
        showOverflow: true
      }, {
        title: '包装单位',
        field: 'packageUnit',
        width: '150px',
        showOverflow: true
      }, {
        title: '规格',
        width: '150px',
        field: 'prodSpecification',
        showOverflow: true
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            const requestApi = props.queryApi || getProdCenterData;
            requestApi(_objectSpread({
              page: page.currentPage,
              pageSize: page.pageSize
            }, form.value)).then(data => {
              res({
                total: data.data.totalSize,
                result: data.data.list
              });
            });
          })
        }
      },
      checkboxConfig: {
        checkMethod({
          row
        }) {
          return !props.selectedIds.find(i => i === row.id);
        }

      }
    });

    function confirm() {
      const selectRows = props.checkMode === 'radio' ? table.value.getRadioRecord() : table.value.getCheckboxRecords();

      if (props.checkMode === 'radio' && !selectRows || props.checkMode === 'checkbox' && selectRows.length === 0) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      if (typeof props.beforeSuccess === 'function') {
        if (props.beforeSuccess(selectRows)) {
          emit('success', selectRows);
          visible.value = false;
        }
      } else {
        emit('success', selectRows);
        visible.value = false;
      }
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form = _resolveComponent("el-form");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "选择商品",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(visible) ? visible.value = $event : null),
        "destroy-on-close": "",
        "append-to-body": "",
        width: "1000px",
        top: "30px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          inline: true
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "商品名称"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.name = $event),
              placeholder: "请输入商品名称和编码"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "生产厂家"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.manufacture,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.manufacture = $event),
              placeholder: "请输入生产厂家"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              icon: "Search",
              type: "primary",
              onClick: _cache[2] || (_cache[2] = $event => table.value.commitProxy('reload'))
            }, {
              default: _withCtx(() => [_hoisted_1]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_grid, _mergeProps({
          height: "630px",
          ref_key: "table",
          ref: table
        }, _unref(tableOptions)), null, 16)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};